import React, { useState, useCallback, useEffect } from 'react';

import { TextAreaWrapper } from './styles';
import { defaultTheme } from './theme';
import { TextAreaProps } from './types';

const TextArea: React.FC<TextAreaProps> = ({
  value,
  placeholder,
  isTextAreaAutoGrowing,
  theme: propsTheme,
  textAreaMinHeight,
  textAreaMaxHeight,
  onChange,
  onChanged,
}) => {
  const theme = { ...defaultTheme, ...propsTheme };
  const [currentValue, setCurrentValue] = useState<string>(value ?? '');

  useEffect(() => {
    if (value !== undefined) {
      setCurrentValue(value);
    }
  }, [value]);

  const onChangeTextarea = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
      setCurrentValue(e.target.value);
      onChange && onChange(e.target.value);
    },
    [setCurrentValue, onChange]
  );

  const handleChanged = useCallback(() => {
    onChanged && onChanged(currentValue);
  }, [onChanged, currentValue]);

  const areaProps = {
    onChange: onChangeTextarea,
    onBlur: handleChanged,
    placeholder,
    value: currentValue,
  };

  return (
    <TextAreaWrapper
      data-autogrowing={currentValue}
      isTextAreaAutoGrowing={isTextAreaAutoGrowing}
      textAreaMaxHeight={textAreaMaxHeight}
      textAreaMinHeight={textAreaMinHeight}
      theme={theme}
    >
      <textarea {...areaProps} />
    </TextAreaWrapper>
  );
};

export default TextArea;
